import React from 'react';
import '../styles/Home.css';
import NavBar from './NavBar';
import Statement from './Statement';
import TabsContainer from './TabsContainer';
import SelfIntro from './Intro';
import Footer from './Footer';
import BlogSection from './BlogSection';

const Homepage = () => {
  return (
      <div className="HomePage" style={styles.gridContainer}>
        <NavBar />
        <Statement />
        <SelfIntro />
        <TabsContainer />
        <BlogSection />
        <Footer/>
      </div>
  );
};

const styles = {
  gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '20px',
      padding: '20px',
  }
};

export default Homepage;